import { Controller } from "@hotwired/stimulus"

// Configuration
// data-auto-disable-enabled-value: activate the disabling of every form fields
export default class extends Controller {
  static values = {
    enabled: {
      type: Boolean,
      default: true,
    },
  }

  connect() {
    if (!this.enabledValue) {
      return;
    }
    // Retrieve all form elements and disable them
    const form_elements = [...this.element.elements].filter((formElement) =>
      ['INPUT', 'SELECT', 'TEXTAREA'].includes(formElement.nodeName)
    );
    form_elements.forEach(formElement => formElement.disabled = true);

    // Retrieve all form labels and update their styles
    const form_labels = this.element.querySelectorAll('.btn-group-toggle label');
    form_labels.forEach(label => {
      label.classList.add('no-hover', 'btn-outline-violet-disabled');
    });
  }
}
